/* eslint-disable no-extra-boolean-cast */
import React, { useEffect } from 'react';
import * as Styles from './SiteAlert.styles';
import useLocale from '@/hooks/useLocale';
import { Alert } from 'gatorcomponents';

const SiteAlert = ({
  type,
  alertVariant,
  customIcon,
  status,
  handleClick,
  daysForPayment,
  sslAnalytics,
  showSSLModal,
  groupMainDomain,
  invoiceId,
}) => {
  useEffect(() => {
    if (type === 'ssl') {
      sslAnalytics && sslAnalytics.sslTags({ status });
    }
  }, [sslAnalytics, status, type]);

  const { sites: sitesLocale } = useLocale();


  const alertDescription = (
    <Styles.Description newSitesAlert>
      <Styles.Text data-testid={`alertDescription${invoiceId || ''}`}>
        {sitesLocale.page.newAlerts[type][status].label({ daysForPayment, groupMainDomain })}
      </Styles.Text>

      {(type === 'ssl' ? showSSLModal : true) && sitesLocale.page.alerts[type][status].button && sitesLocale.page.alerts[type][status].button({
        handleClick,
        invoiceId,
      })}
    </Styles.Description>
  );

  return (
    <Alert
      description={alertDescription}
      variant={alertVariant}
      customIcon={customIcon && customIcon}
      width="full"
    />
  );
};

export default SiteAlert;
